module.exports = __webpack_public_path__ + "static/curso_extintor-89e341d2fb2646638d469f4bba6abea7.jpg";